import React from "react";
import "../assets/css/Services.css";
// import imgServices from "../assets/img/ilustration-services.webp";


import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import videoBG from "../assets/mp4/service.mp4";

import serviceVD01 from "../assets/mp4/service/service_vd01.mp4";
import serviceVD02 from "../assets/mp4/service/service_vd02.mp4";
import serviceVD03 from "../assets/mp4/service/service_vd03.mp4";
import serviceVD04 from "../assets/mp4/service/service_vd04.mp4";
import serviceVD05 from "../assets/mp4/service/service_vd05.mp4";
import serviceVD06 from "../assets/mp4/service/service_vd06.mp4";
import serviceVD07 from "../assets/mp4/service/service_vd07.mp4";





const cardsServices = [
  {
    videoSrc: serviceVD01,
    imgAlt: "Desenvolvimento",
    title: "Desenvolvimento de Software",
    subtitle: "Criamos soluções personalizadas que aceleram o crescimento do seu negócio, com alta performance, segurança e escalabilidade.",
  },
  {
    videoSrc: serviceVD02,
    imgAlt: "Consultoria em sistemas",
    title: "Consultoria em Sistemas",
    subtitle: "Transforme sua operação com soluções estratégicas que aumentam a eficiência, reduzem custos e preparam sua empresa para o futuro digital.",
  },
  {
    videoSrc: serviceVD03,
    imgAlt: "UX e UI Design",
    title: "UX e UI Design",
    subtitle: "Desenvolvemos experiências digitais intuitivas e envolventes, melhorando a satisfação do usuário e impulsionando a conversão.",
  },
  {
    videoSrc: serviceVD04,
    imgAlt: "Business Intelligence (BI)",
    title: "Business Intelligence (BI)",
    subtitle: "Desenvolvemos experiências digitais intuitivas e envolventes, melhorando a satisfação do usuário e impulsionando a conversão.",
  },
  {
    videoSrc: serviceVD05,
    imgAlt: "Consultoria em LGPD",
    title: "Consultoria em LGPD",
    subtitle: "Garanta a proteção dos dados dos seus clientes e a conformidade com a LGPD, evitando riscos e fortalecendo a confiança na sua marca.",
  },
  {
    videoSrc: serviceVD06,
    imgAlt: "Consultoria em CRM",
    title: "Consultoria em CRM",
    subtitle: "Aumente a eficiência da sua equipe de vendas e melhore o relacionamento com seus clientes, utilizando as melhores práticas de CRM para maximizar resultados.",
  },
  {
    videoSrc: serviceVD07,
    imgAlt: "Inteligência Artificial (IA)",
    title: "Inteligência Artificial (IA)",
    subtitle: "Impulsione a inovação no seu negócio com soluções de IA que automatizam processos, melhoram a experiência do cliente e geram insights valiosos.",
  },
];

const CardsServices = ({ videoSrc, imgAlt, title, subtitle }) => (
  <div className="card-services">
      <div className="row  ">
        <div className="col-12 col-md-5 align-content-center  ">
          <div className="change-border"  >
            <video autoPlay loop muted playsInline  className="video-card-services  " width="100%"  height="170"  >
              <source src={videoSrc} type="video/mp4" />
              Seu navegador não suporta o elemento de vídeo.
            </video>
          </div>
        </div>
        <div className="col-12 col-md-7">
          <div className="content-card-services text-start">
            <p className="text-card-services">{title}</p>
            <p className="subtitle-card-services">{subtitle}</p>
          </div>
        </div>
      </div>

  </div>
);

const Services = () => {

  return (
    <div>
      <div className="bg-services row align-items-center justify-content-center">
        <div className="col-xl-8">
          <div className="content-services text-start">
            <p className="title-services">Nossos Serviços</p>
            <p className="text-services">Na GAO TECH, transformamos desafios em oportunidades com soluções tecnológicas que impulsionam sua empresa para o futuro. Garantimos eficiência, resultados excepcionais e uma experiência digital aprimorada, acelerando sua transformação digital e maximizando o potencial do seu negócio.
            </p>
          </div>
        </div>

        <div className="col-xl-4">

          <div className="man-services  ">
            <video autoPlay loop muted playsInline className="video-background">
              <source src={videoBG} type="video/mp4" />
              Seu navegador não suporta o elemento de vídeo.
            </video>
          </div>
        </div>

      </div>
      <div className="row row-services">
        <div className="card-section-services">
          <Swiper
            slidesPerView={1.8}
            spaceBetween={20}
            navigation={true}
            modules={[Navigation]}
            className="mySwiperServices"
            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 15,
              },
              768: {
                slidesPerView: 1,
                spaceBetween: 15,
              },
              1444: {
                slidesPerView: 1,
                spaceBetween: 15,
              },
              1530: {
                slidesPerView: 1,
                spaceBetween: 15,
              },
              1600: {
                slidesPerView: 1.8,
                spaceBetween: 15,
              }


            }}
          >
            {cardsServices.map((cards, index) => (
              <SwiperSlide key={index}>
                <CardsServices {...cards} />
              </SwiperSlide>
            ))}
          </Swiper>

        </div>
      </div>
  </div>
  );
};

export default Services;
